<template>
  <div>
    <div v-for="(el,index) in list" :key="el.id">
      <div v-if="(index < max && index >= min) || el.parentId !== '0'" :style="{'margin-top': el.parentId !== '0' ? '0' : (index === min ? 0 : '35px')}">
        <div v-if="el.children">
          <h3 class="menuTitle">{{el.name}}</h3>
          <menu-ul style="padding-left: 5px;" :list="el.children" />
        </div>
        <p v-else :class="{choiceStyle: src.indexOf(el.path) > 0}" class="menuName" @click="() => handleClick(el)">{{el.name}}</p>
      </div>
    </div>
  </div>
</template>
<script>
import MenuUl from './MenuUl.vue'
import { mapMutations } from 'vuex'
export default {
  name:'menu-ul',
  props:['list','sort','len','max','min'],
  components: {MenuUl},
  data(){
    return{
      name: 'menu-ul',
      src: window.location.href
    }
  },
  methods:{
    ...mapMutations('home',['setState']),
    handleClick(e) {
      this.setState({menuVisible: false})
      const url = e.path.indexOf('?')!== -1 ? `${e.path}&name=${e.name}` : `${e.path}?name=${e.name}`
      this.$router.push(url)
    },
  }
}
</script>

<style lang="scss" scoped>
.menuTitle{
  font-size: 16px;
  color: #1677FF;
  font-weight: bold;
  // border-left: 2px solid #1677FF;
  padding-left: 10px;
  position: relative;
  &:after{
    content: '';
    width: 4px;
    height: 12px;
    background: #1677FF;
    position: absolute;
    left: 0;
    top: 6px;
  }
}
.menuName{
  cursor: pointer;
  // display: inline-block;
  padding: 0 5px;
  margin-bottom: 5px;
  line-height: 26px;
  font-size: 14px;
}
.choiceStyle{
  background: #f5f7fa;
  color: #1677FF;
}
.half{
  width: 50%;
  display: inline-block;
  // float: left;
}
</style>